import { Box, Button, Dialog, Typography } from '@mui/material';
import { useDisclose } from 'basic-react-hooks';
import CreditChart from 'components/Chart/Credit/CreditChart';
import { LightningIcon } from 'components/Icons';
import ModalInvoiceBuy from 'components/Modal/ModalInvoiceBuy';
import React, { useState } from 'react';
import ListInvoices from './ListInvoices';
import CloseBtnModal from 'components/Button/CloseBtnModal';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector';
import RefreshBtn from 'components/Button/RefreshBtn';
import useFetchPublicUserInfo from 'hooks/useFetchPublicUserInfo';

const ModalManageSubscriptions = ({ open, onClose }) => {
  const { isOpen, onOpen, onClose: _onClose } = useDisclose();
  const [invoiceSelected, setInvoiceSelected] = useState(null);
  const publicUser = useShallowEqualSelector((state) => state.publicUser.user);

  const { getUserInfo, isLoading } = useFetchPublicUserInfo(false);

  const onClickView = (invoice) => {
    setInvoiceSelected(invoice);
    onOpen();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={'md'}
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
    >
      <CloseBtnModal onClick={onClose} />
      <Box p={2}>
        <Typography flex={1} fontWeight={600} mb={2} fontSize={16}>
          Manage Credits
        </Typography>
        <Box
          borderRadius={'12px'}
          px={'10px'}
          py={'12px'}
          bgcolor={'rgba(247, 247, 247, 1)'}
          border={'1px solid rgba(239, 239, 239, 1)'}
        >
          <Box display={'flex'} alignItems={'center'} mb={'6px'}>
            <Typography fontWeight={700}>
              {publicUser.verifyCredits} verify credits
            </Typography>
            <RefreshBtn onRefresh={getUserInfo} isFetchingData={isLoading} />
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <Box flex={1}>
              <CreditChart
                usedCredit={publicUser?.usedVerifyCredits}
                totalCredit={publicUser?.verifyCredits}
              />
            </Box>
            <Box>
              <Button
                sx={{ color: 'white' }}
                startIcon={<LightningIcon fill={'white'} />}
                variant="contained"
                onClick={() => {
                  setInvoiceSelected(null);
                  onOpen();
                }}
              >
                Increase Credit
              </Button>
            </Box>
          </Box>
        </Box>
        <Box>
          <ListInvoices onViewInvoice={onClickView} />
        </Box>
      </Box>
      <ModalInvoiceBuy
        open={isOpen}
        onClose={_onClose}
        _invoiceSelected={invoiceSelected}
      />
    </Dialog>
  );
};

export default ModalManageSubscriptions;
